import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component } from 'react';
import { DataProgramme } from '../../data/DataProgramme.jsx';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAgence } from '../ComboBox/ComboBoxAgence';
import { ComboBoxRegion } from '../ComboBox/ComboBoxRegion';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { PickerCPVille } from '../Picker/PickerCPVille';

/*
******************************************************************************
PROPS :
    ATTRIBUTS :
        int     idProgramme                 ID du programme à modifier
        int     idRegion
        int     idAgence
        bool    isOpen                      détermine si panel ouvert ou non
    METHODES :
        void    onAnnulation                méthode appelée à la fermeture
        void    onEnregistrement            méthode appelée à l'enregistrement
******************************************************************************
*/

export class FicheProgramme extends Component {

    constructor(props) {
        super(props);
        this.objetState = {
            programme: {},

            messageEnCoursTraitement: '',
            hideMessageBarError: true,
            errorMessage: '',
            hideMessageBarWarning: true,
            warningMessage: '',

            onActiveBoutonEnregistrer: false
        };
        this.state = this.objetState;
    };

    _chargementDonnees = () => {
        if (this.props.idProgramme != 0 && this.props.idRegion != 0 && this.props.idAgence != 0) {

            this.setState({ messageEnCoursTraitement: "Chargement du programme en cours..." });

            DataProgramme._chargementProgramme(
                this.props.idProgramme,
                this.props.idRegion,
                this.props.idAgence).then(responseFetch => {
                    const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                    if (retourVerif === null) {
                        const programme = responseFetch.reponseAPIobjet;
                        this.setState(
                            {
                                programme: programme,
                                messageEnCoursTraitement: "",
                            },
                            () => this._onVerificationFormulaire());
                        //this._setErrorMessages(["programme", "programmeCommercial", "cp", "ville", "idRegion", "idAgence"])
                        //)
                    }
                    else
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                });
        }
        else {
            this.objetState = {
                programme: {},
                messageEnCoursTraitement: '',
                hideMessageBarError: true,
                errorMessage: '',
                hideMessageBarWarning: true,
                warningMessage: '',

                onActiveBoutonEnregistrer: false
            };
        }
    };

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'Programme', this.state.programme, (this.props.idProgramme != "" ? 'Modification' : 'Création'));
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnulation();
    };

    _onChangeInput = (champs) => (event, newValue) => {
        const programme = { ...this.state.programme };
        programme[champs] = newValue;

        this.setState(
            { programme: programme },
            this._onVerificationFormulaire
        );
    };

    _onMiseAJourChamp(nomPropriete, valeur) {
        const programme = { ...this.state.programme };

        if (nomPropriete == "idRegion") {
            programme.idRegion = valeur;
            programme.idAgence = null;
        }
        else if (nomPropriete == "idAgence") {
            programme.idAgence = valeur;
        }

        this.setState(
            { programme: programme },
            this._onVerificationFormulaire
        );
    }

    _onEnregistrement = () => {

        this.setState({ messageEnCoursTraitement: "Programme en cours d'enregistrement..." });

        const objet = {
            programme: this.state.programme
        };

        DataProgramme._onEnregistrementProgramme(objet).then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                this._onInit();
                this.props.onEnregistrement();
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });

    };

    _onInit = () => {
        this.setState(this.objetState);
    };

    _onOpen = () => {
        this._chargementDonnees();
    };

    _onRenderFooterContent = () => {
        return <Stack horizontal tokens={{ childrenGap: 10 }}>
            <PrimaryButton name="btnFPEnregistrer" onClick={this._onEnregistrement} disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
            <DefaultButton onClick={this._onAnnulation}>Annuler</DefaultButton>
        </Stack>
    };

    _onMiseAJourChampCPVille(ville, cp) {
        const programme = this.state.programme;
        programme.cp = cp;
        programme.ville = ville;

        this.setState(
            { programme: programme },
            this._onVerificationFormulaire());
    }

    render = () => {

        var modeCreation = (this.state.programme.idProgramme == undefined);
        var disabledRegion = !modeCreation;
        var disabledAgence = disabledRegion || (!disabledRegion && !(this.state.programme.idRegion > 0));

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText={this.props.idProgramme ? "Modifier un programme" : "Créer un programme"}
            isOpen={this.props.isOpen}
            onDismiss={this._onAnnulation}
            onOpen={this._onOpen}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.medium}
        >

            {this.state.messageEnCoursTraitement.length > 0 ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />
            <EUITextField
                data-testid="divProgramme"
                label="Programme"
                maxLength={MaxLengths.programme.programme}
                onDelayedChange={this._onChangeInput("programme")}
                required
                value={this.state.programme.programme}
            />
            <EUITextField
                data-testid="divProgrammeCommercial"
                label="Programme commercial"
                maxLength={MaxLengths.programme.programmeCommercial}
                onDelayedChange={this._onChangeInput("programmeCommercial")}
                required
                value={this.state.programme.programmeCommercial}
            />
            <EUITextField
                data-testid="divAdresse"
                label="Adresse"
                maxLength={MaxLengths.programme.adresse}
                onDelayedChange={this._onChangeInput("adresse")}
                value={this.state.programme.adresse}
            />
            <EUITextField
                data-testid="divComplementAdresse"
                label="Complément d'adresse"
                maxLength={MaxLengths.programme.complementAdresse}
                onDelayedChange={this._onChangeInput("complementAdresse")}
                value={this.state.programme.complementAdresse}
            />
            <PickerCPVille
                data-testid="divCPVille"
                required
                cp={this.state.programme.cp}
                villeAdministrative={this.state.programme.ville}
                onChange={(idVilleAdm, idDeptAdm, idRegionAdm, cp, ville) => this._onMiseAJourChampCPVille(ville, cp)}
                onBlur={(cp, ville) => this._onMiseAJourChampCPVille(ville, cp)}
            />
            <ComboBoxRegion
                data-testid="divRegion"
                disabled={disabledRegion}
                onChange={(event, option, index, value, item) => this._onMiseAJourChamp("idRegion", option.key)}
                required
                selectedKey={this.state.programme.idRegion}
            />
            <ComboBoxAgence
                data-testid="divAgence"
                disabled={disabledAgence}
                idRegion={this.state.programme.idRegion}
                onChange={(event, option, index, value, item) => this._onMiseAJourChamp("idAgence", option.key)}
                required
                selectedKey={this.state.programme.idAgence}
            />
        </Panel>;
    };
}
